import qs from "qs"
import axios from "../axios"
import { AxiosResponse } from "axios"
import { MonitorObjectPrimitive, Primitive } from "@/interface/primitive"

export function savePrimitives(projectUuid: string, blueprintUuid: string, primitives: Primitive[], params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectUuid}/blueprintUuid/${blueprintUuid}/primitives`, primitives, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function findPrimitivesInProject(projectUuid: string, blueprintUuid: string, type?: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/projects/${projectUuid}/blueprintUuid/${blueprintUuid}/primitives`, {
        params: {
            type: type,
            ...params,
        }
    })
}

// 通过项目ID获取关联表列表
export function findMonitorObjectPrimitiveByProjectId(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/projects/${projectId}/monitor-object-primitive`, {
        params: {
            ...params,
        }
    })
}
//通过图元uuid获取具体的关联表
export function findMonitorObjectPrimitiveByPrimitiveUuid(projectId: number, primitiveUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/projects/${projectId}/monitor-object-primitive/${primitiveUuid}`, {
        params: {
            ...params,
        }
    })
}

//新建监测数据与图元的关联信息，仅添加一条
export function addMonitorObjectPrimitive(projectId: number, monitorObjectId: number, primitiveUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectId}/monitorObject/${monitorObjectId}/primitive/${primitiveUuid}/monitor-object-primitive`, null, {
        params: {
            ...params,
        }
    })
}

//新建监测数据与图元的关联信息，添加多条
export function addMonitorObjectPrimitives(projectId: number, data: MonitorObjectPrimitive[], params?: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectId}/monitor-object-primitive`, data, {
        params: {
            ...params,
        }
    })
}

//更新监测数据与图元的关联信息
export function updateMonitorObjectPrimitive(primitiveUuid: string, data: MonitorObjectPrimitive, params?: {}): Promise<AxiosResponse<any>> {
    return axios.put(`/monitor-object-primitive/${primitiveUuid}`, data, {
        params: {
            ...params,
        }
    })
}
//删除监测数据与图元的关联信息
export function deleteMonitorObjectPrimitive(primitiveUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return axios.delete(`/monitor-object-primitive/${primitiveUuid}`, {
        params: {
            ...params,
        }
    })
}

// 新建球体
export function generateBallPrimitive(projectUuid: string, blueprintUuid: string, params: any): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectUuid}/blueprintUuid/${blueprintUuid}/generateBall`, params);
}
//移动球体
export function movePrimitive(projectUuid: string, blueprintUuid: string, params: any): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectUuid}/blueprintUuid/${blueprintUuid}/movePrimitive`, params);
}

//删除球体
export function deletePrimitive(projectUuid: string, blueprintUuid: string, uuid: string): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectUuid}/blueprintUuid/${blueprintUuid}/deletePrimitive`, { uuid });
}

export function changePrimitiveColor(projectUuid: string, modelUuid: string, data: any): Promise<AxiosResponse<any>> {
    return axios.post(`/projects/${projectUuid}/blueprintUuid/${modelUuid}/changeColor`, data);
}
